import LocalResponse from "../fetch/Response";

export interface OriginData {
  [key: string]: any;
}

type IncomingData = OriginData | Promise<OriginData>;

/**
 * 转换key
 * @param key
 */
export function toCamelKey(key: string) {
  return key.replace(/_+([a-zA-Z])/g, (str, char, index) => {
    if (index === 0) {
      return char.toLowerCase();
    }

    return char.toUpperCase();
  });
}

/**
 * 转下划线
 * @param key
 */
export function toUnderKey(key: string) {
  return key
    .replace(/[A-Z]/g, (char, index) => {
      if (index === 0) {
        return char.toLowerCase();
      }

      return `_${char.toLowerCase()}`;
    })
    .replace(/_+/g, "_");
}

/**
 * 构造key格式转换器
 * @param keyTransfer
 * @param strict_mode 严格模式，不允许出现相同key的情况
 */
export function transferKeyFactor(
  keyTransfer: (key: string) => string,
  strict_mode = false,
) {
  function loopArray(arr: any[]) {
    return arr.map(item => {
      if (typeof item === "object") {
        if (item instanceof Array) {
          return loopArray(item);
        }

        return loopObject(item);
      }

      return item;
    });
  }
  // 循环处理对象的属性
  function loopObject(obj: any) {
    if (obj === null || obj === undefined) {
      return obj;
    }

    const key_exist_map = {};
    return Object.keys(obj).reduce((res, key) => {
      const res_key = keyTransfer(key);
      if (strict_mode) {
        if (key_exist_map[res_key]) {
          throw new Error(
            `以下key映射后的键值重复：${key_exist_map[res_key]}、${key}`,
          );
        } else {
          key_exist_map[res_key] = key;
        }
      }
      if (typeof obj[key] === "object") {
        if (obj[key] instanceof Array) {
          res[res_key] = loopArray(obj[key]);
        } else {
          res[res_key] = loopObject(obj[key]);
        }
      } else {
        res[res_key] = obj[key];
      }

      return res;
    // 如果是response实例，则直接用原对象，避免部分属性丢失
    }, obj instanceof LocalResponse ? obj : {});
  }

  // 处理原始输入是promise的情况
  async function handlePromiseData(origin: Promise<OriginData>) {
    const data = await origin;
    return loopObject(data);
  }

  return <T = any>(data: IncomingData): T => {
    let origin = data;
    // 如果是函数，取调用后的值
    if (typeof data === "function") {
      origin = data();
    }

    // 如果值是promise，等他的resolve
    if (origin instanceof Promise) {
      return handlePromiseData(origin) as any;
    }

    // 处理数据
    return loopObject(origin);
  };
}

/**
 * 将下划线的字段名转成驼峰
 * @param data
 */
export const toCamelCase = transferKeyFactor(toCamelKey);

/**
 * 将驼峰的字段名转成下划线
 * @param data
 */
export const toUnderCase = transferKeyFactor(toUnderKey);
